import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchAllEvents, deleteEvent } from '../../lib/eventsApi';

export default function EventsList() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      setEvents(await fetchAllEvents());
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleDelete = async (id, title) => {
    if (!window.confirm(`Delete "${title}"?`)) return;
    await deleteEvent(id);
    load();
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-brand-dark">Events</h1>
          <p className="text-gray-500">Manage upcoming and past events.</p>
        </div>
        <Link
          to="/admin/events/new"
          className="bg-brand-purple text-white px-4 py-2 rounded-lg text-sm font-medium hover:opacity-90"
        >
          + New event
        </Link>
      </div>

      {loading ? (
        <p>Loading…</p>
      ) : events.length === 0 ? (
        <p className="text-gray-500">No events yet.</p>
      ) : (
        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-left">
              <tr>
                <th className="p-4 font-medium">Title</th>
                <th className="p-4 font-medium">Date</th>
                <th className="p-4 font-medium">Status</th>
                <th className="p-4 font-medium text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {events.map((ev) => (
                <tr key={ev.id} className="border-t border-gray-100">
                  <td className="p-4">{ev.title}</td>
                  <td className="p-4 text-gray-500">{new Date(ev.date).toLocaleString()}</td>
                  <td className="p-4">
                    <span className={`px-2 py-0.5 rounded text-xs ${ev.status === 'published' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}`}>
                      {ev.status}
                    </span>
                  </td>
                  <td className="p-4 text-right space-x-3">
                    <Link to={`/admin/events/${ev.id}`} className="text-brand-purple hover:underline">Edit</Link>
                    <button type="button" onClick={() => handleDelete(ev.id, ev.title)} className="text-red-600 hover:underline">Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
